const Mutations = {
    set_auth_user: 'setAuthUser',
    set_taxonomies: 'setTaxonomies',
    set_csrf: 'setCsrf',
    set_vehicle_years: 'setVehicleYears',
    set_vehicle_makes: 'setVehicleMakes',
    set_vehicle_models: 'setVehicleModels',
    set_vehicle_trims: 'setVehicleTrims',
};

export default Mutations
